import { render, staticRenderFns } from "./O3DWindow.vue?vue&type=template&id=4cdc3782&"
import script from "./O3DWindow.vue?vue&type=script&lang=js&"
export * from "./O3DWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports